<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title"
    show-close
    width="1000px"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      style="margin-top: 1.6rem !important;"
      :tableData="tableData"
      @close="close()"
      @checkboxChange="(e) => (checkedRecords = e)"
    />
    <span slot="footer" v-if="tableExist">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="exportRecords()"
        :disabled="checked"
      >
        {{ '按发运单导出' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="exportRecords()"
        :disabled="!checked"
      >
        {{ $l('INDEX.btn_export_selection_record') || '导出选择记录' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      checkedRecords: [],
      tableExist: true,
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    checked() {
      return !!(this.checkedRecords && this.checkedRecords.length)
    },
  },
  methods: {
    loadData() {
      this.loading = true
      this.$api
        .shipmentBookingListApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data

          this.tableExist = !!(this.tableData && this.tableData.length)
        })
        .catch(() => {
          this.loading = false
        })
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
      this.checkedRecords = []
    },
    exportRecords() {
      const context = {
        shipmentCode: this.shipmentCode,
        listBookingCode: !this.checked
          ? []
          : this.checkedRecords.map((item) => item.shipmentBookingCode),
      }
      this.$emit('confirm', context)
    },
    clearCheck() {
      this.checkedRecords = []
      this.$refs.main.clearCheck()
    },
  },
}
</script>

<style scoped></style>
